var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-data"},[_vm._t("default"),(_vm.isImg)?_c('img',{attrs:{"src":_vm.noDataImg,"alt":""}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.label || _vm.$t('noData')))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }